var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSquarearrowupright20(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Symbols",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    strokeLinecap: "round"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icons/Cloud/20/Open",
    stroke: "currentColor",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.25 11.442v1.726c0 1.072-.112 1.46-.321 1.852-.21.392-.517.7-.909.909-.391.21-.78.321-1.852.321H6.832c-1.072 0-1.46-.112-1.852-.321-.392-.21-.7-.517-.909-.909-.21-.391-.321-.78-.321-1.852V6.832c0-1.072.112-1.46.321-1.852.21-.392.517-.7.909-.909.391-.21.78-.321 1.852-.321h1.726",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path-2",
    d: "M16 4l-6 6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path-5",
    strokeLinejoin: "round",
    d: "M12.25 3.75h4v4"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSquarearrowupright20);
export default __webpack_public_path__ + "static/media/square.arrow.up.right-20.d1932993.svg";
export { ForwardRef as ReactComponent };